module.exports = __webpack_public_path__ + "static/media/logoTicketFooter.3fe6c033.png";